import type { DatafileContent, FeaturevisorLogLevel } from '@featurevisor/sdk';

export const FEATURES_CONST = {
  defaultLogLevel: 'warn' as FeaturevisorLogLevel,
  defaultCacheDuration: 5 * 60,
};

// Empty datafile used as a fallback so evaluations return defaults instead of throwing
export const EMPTY_DATAFILE: DatafileContent = {
  schemaVersion: '2',
  revision: '0',
  segments: {},
  features: {},
};
